import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { PurchaseService } from "../../services/purchase.service";

import { Purchase } from "../../models/purchase.model";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

import { UserService } from "../../@core/services/user.service";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import Shop from "../../models/shop.model";
import { User } from "../../@core/data/users";
import { DialogPrintPurchaseComponent } from "../dialog-print-purchase/dialog-print-purchase.component";

@Component({
  selector: "ngx-view-purchase",
  styleUrls: ["./view-purchase.component.scss"],
  templateUrl: "./view-purchase.component.html",
})
export class ViewPurchaseComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop = new Shop();

  @Input() purchase: Purchase;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onClosed: EventEmitter<any> = new EventEmitter();

  @Input() mode?: string = ""; //home / purchase / detail

  isMore? = false;
  loading = false;
  submitted = false;
  view = "main";
  uid = "";
  isMobile = false;
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];
  user?: User;

  constructor(
    public userService: UserService,
    private purchaseService: PurchaseService,
    private dialogService: NbDialogService,
    private router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    if (this.mode === "detail") {
      this.isMore = true;
    }

    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.purchase.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadContent() {
    this.isMore = !this.isMore;
  }

  loadButtonAction(item) {
    this.menuItems = [
      { title: "Sửa", icon: "edit-2-outline", data: item },
      { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
      {
        title: "Chi tiết",
        icon: "external-link-outline",
        link: `/purchase/${this.purchase.id}`,
      },
    ];
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.loading = true;
          this.purchaseService.delete(this.shopId, item.id).then(
            (result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            },
            (error) => {
              this.loading = false;
              this.submitted = false;
            }
          );
        }
      });
  }

  edit(item: Purchase) {
    this.onClosed.emit(item.id);
    if (item.isTrade && item.receiptId) {
      this.router.navigateByUrl("/receiptpurchase/" + item.receiptId);
    } else {
      this.router.navigateByUrl("/purchase/" + item.id);
    }
  }

  messageErr = "";
  printPurchase() {
    this.dialogService
      .open(DialogPrintPurchaseComponent, {
        context: {
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          purchase: this.purchase,
          shop: this.shop,
          rePrint: true,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }
}
